"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumBN = void 0;
const web3_1 = __importDefault(require("web3"));
exports.sumBN = (numbers) => {
    let sum = web3_1.default.utils.toBN('0');
    numbers.forEach(number => {
        sum = sum.add(web3_1.default.utils.toBN(number));
    });
    return sum.toString();
};
//# sourceMappingURL=sumBN.js.map